import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { util } from '@glowforge/ui-common';
import strings from 'app/strings';

import './page-not-found.less';

const { analytics: {
  gtmEvent,
} } = util;

class PageNotFound extends React.Component {
  componentDidMount() {
    // Log 404 event for analytics
    const referrer = _.get(this.props, 'location.query.ref');
    if (referrer) {
      // page was redirected by ecomm-core with query param as original route.
      gtmEvent('404', { referrer });
    } else {
      // Page is 404 on ecomm-front-end (route is either 404 or client side)
      const route = _.get(this.props, 'location.pathname');
      gtmEvent('404', { route });
    }
  }

  render() {
    return (
      <div className='PageNotFound'>
        <Helmet title='Page Not Found' />
        <h1 className='h1'>404</h1>
        <h4 className='h4'>{strings.PAGE_NOT_FOUND_SUB}</h4>
      </div>
    );
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./app/components/page-not-found.jsx